import React from 'react';
import { Form, Select } from 'antd';
const { Option } = Select;
// onChange={onChangeViewOrder}

const Carriers = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Перевозчик:">
      {getFieldDecorator('carriers')(
        <Select
          getPopupContainer={trigger => trigger.parentNode}
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите перевозчика"
          allowClear={true}
          maxTagCount={0}
        >
          <Option key={1}>API не подключено</Option>
        </Select>
      )}
    </Form.Item>
  );
};

export default Carriers;
